import { graphql } from '../../gql';

export const COMPOSITION_TOOLTIP = graphql(`
  query CompositionTooltip(
    $entities: [CompositionV2Entity!]!
    $filters: CompositionV2FullSnapshotFilters!
  ) {
    composition_v2_tooltip(req: { filters: $filters, entities: $entities }) {
      entities {
        scaled {
          headcount {
            id
            value
          }
          salary {
            id
            value
          }
        }
      }
    }
  }
`);

export const POSTING_TOOLTIP = graphql(`
  query PostingTooltip($dim1: Dimension1, $filters: PostingFilters) {
    posting(filters: $filters, dim1: $dim1, dim2: date) {
      metadata {
        id
        shortName
        longName
      }
      category {
        metadata {
          shortName
        }
        metrics {
          time_to_fill
          active
        }
      }
    }
  }
`);
